import { createStore } from 'vuex';
import { analytics } from '@/vuex/plugins/analytics';
import { socketIoPlugin } from '@/vuex/plugins/websocket.util';
import session from '@/vuex/plugins/session';
import modules from './modules';

function useStrictMode () {
    return false;
    // return process.env.NODE_ENV !== 'production' && !window.Cypress;
}

function getStore () {
    return createStore({
        modules,
        plugins: [analytics, socketIoPlugin, session],
        strict: useStrictMode(),
    });
}

const store = getStore();

export default store;

// Used in Cypress Component Testing
export { getStore };
